import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  dialogContent: {
    '&&': {
      padding: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3),
      },
    },
  },
  formFields: {
    gap: theme.spacing(2),
  },
}));
